var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3085 19.191L16.1675 21.3C15.0511 20.6263 14.0139 19.8293 13.0755 18.924C12.1719 17.9851 11.3754 16.9487 10.7005 15.834L12.8105 13.693C12.9371 13.5635 13.0226 13.3995 13.0562 13.2216C13.0899 13.0437 13.0701 12.8597 12.9995 12.693L10.8005 7.56C10.7136 7.3578 10.5569 7.19356 10.359 7.09719C10.1612 7.00083 9.93525 6.97876 9.72247 7.035L5.68847 8.1C5.4865 8.15234 5.30836 8.27184 5.18332 8.43886C5.05828 8.60588 4.9938 8.81047 5.00047 9.019C5.25738 13.7104 7.20814 18.1492 10.4905 21.511C13.8534 24.7938 18.2938 26.7443 22.9865 27C23.1947 27.0066 23.3991 26.942 23.5657 26.817C23.7324 26.6919 23.8515 26.5138 23.9035 26.312L24.9695 22.276C25.026 22.0633 25.0042 21.8374 24.908 21.6395C24.8118 21.4416 24.6476 21.2849 24.4455 21.198L19.3165 19C19.1486 18.9277 18.9629 18.9073 18.7833 18.9413C18.6037 18.9754 18.4383 19.0623 18.3085 19.191V19.191Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 5C20.3874 5 22.6766 5.94821 24.3644 7.63604C26.0522 9.32387 27.0005 11.6131 27.0005 14",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 9C19.3265 9 20.5983 9.52678 21.536 10.4645C22.4737 11.4021 23.0005 12.6739 23.0005 14",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.8bcb8fb1da842355ce44c5c3850adb27.svg";
export { ForwardRef as ReactComponent };